<template>
  <div class="base-checkbox-group form-group">
    <b-form-group :label="label">
      <b-form-checkbox-group
        :checked="_value"
        :name="name"
        :options="options"
        :errors="errors"
        :stacked="stacked"
        :disabled="disabled"
        v-on="$listeners" />
    </b-form-group>
    <BaseErrorMessage
      :color="errorTextColor"
      :errors="errors" />
  </div>
</template>

<script>
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  components: {
    BaseErrorMessage
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: undefined
    },
    errors: {
      type: Array,
      default: () => []
    },
    errorTextColor: {
      type: String,
      default: 'primary'
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    stacked: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    }
  }
}
</script>

<style>

</style>